module.exports = __webpack_public_path__ + "img/ico_1.07fdca3e.png";